import React, { Component } from 'react';
import componentLookUp from '../../../shared/core/components.map';

type FsSharedPagePropsType = {
    components: string[]
}

type FsSharedPageState = {
    isLoaded: boolean,
    error: null,
    data: any
}

class FsSharedPage extends Component<FsSharedPagePropsType, FsSharedPageState> {
    render() {
        return(
            <>
                { this.props.components.map( (comp, index) => 
                    <div key={index}>{ componentLookUp(comp) }</div>
                )}
            </>
        )
    }
}

export default FsSharedPage;